import { useState } from "react"
import axios from "axios"
import ReactMarkdown from "react-markdown"

export default function App() {
  const [text, setText] = useState("")
  const [result, setResult] = useState(null)
  const [loading, setLoading] = useState(false)
  const [answers, setAnswers] = useState({})

  const score = result?.quiz
    ? Object.keys(answers).filter(
      (i) => answers[i] === result.quiz[i].answer
    ).length
    : 0

  const handleAnswer = (qIndex, option) => {
    if (answers[qIndex]) return
    setAnswers({ ...answers, [qIndex]: option })
  }

  const handleSubmit = async () => {
    setLoading(true)
    const res = await axios.post("https://multi-study-ai-assistant.onrender.com/process", { text })
    setResult(res.data)
    setLoading(false)
  }

  return (
    <div className="min-h-screen bg-gray-900 text-white p-6">

      {/* Header */}
      <h1 className="text-4xl font-bold mb-6 text-center">
        🤖 AI Study Agent
      </h1>

      {/* Input Card */}
      <div className="bg-gray-800 p-6 rounded-xl shadow-lg mb-6">
        <textarea
          rows="5"
          className="w-full p-3 rounded-lg text-black"
          placeholder="Paste your notes here..."
          onChange={(e) => setText(e.target.value)}
        />

        <button
          onClick={handleSubmit}
          className="mt-4 bg-blue-600 hover:bg-blue-700 px-6 py-2 rounded-lg font-semibold"
        >
          {loading ? "Generating..." : "Generate"}
        </button>
      </div>

      {result?.explanation && (
        <div className="bg-gray-800 p-6 rounded-xl shadow-lg mb-6">
          <h2 className="text-2xl font-semibold mb-3">📖 Explanation</h2>

          <div className="prose prose-invert max-w-none">
            <ReactMarkdown>
              {result.explanation}
            </ReactMarkdown>
          </div>
        </div>
      )}

      {result?.quiz && (
        <div className="mb-4 text-lg font-semibold">
          Score: {score} / {result.quiz.length}
        </div>
      )}


      {/* Result */}
      {result?.quiz?.map((q, index) => (
        <div key={index} className="bg-gray-800 p-5 rounded-xl shadow-lg">

          <h3 className="text-lg font-semibold mb-3">
            {index + 1}. {q.question}
          </h3>

          <div className="space-y-2">

            {q.options.map((opt, i) => {
              const labels = ["A", "B", "C", "D"]
              const selected = answers[index]

              let bg = "bg-gray-700"

              if (selected) {
                if (opt === q.answer) bg = "bg-green-600"
                else if (opt === selected) bg = "bg-red-600"
              }

              return (
                <button
                  key={i}
                  onClick={() => handleAnswer(index, opt)}
                  className={`block w-full text-left p-2 rounded ${bg}`}
                >
                  {labels[i]}. {opt}
                </button>
              )
            })}
          </div>

          {/* Show correct answer */}
          {answers[index] && (
            <p className="mt-2 text-green-400">
              ✔ Correct: {q.answer}
            </p>
          )}
        </div>
      ))}
    </div>
  )
}